import {
  MotifIcon,
} from "@ey-xd/motif-react";
import { IconoirWarningTriangle } from "@ey-xd/motif-icon";
import { useTranslation } from "react-i18next";

export function CommonModalHeader() {
  const { t } = useTranslation();

  return (
    <>
      <span
        style={{
          backgroundColor: "rgb(252, 245, 243)",
          borderRadius: "50px",
          padding: "5px 8px 2px 8px",
        }}
      >
        <MotifIcon
          iconFunction={IconoirWarningTriangle}
          strokeWidth="1"
          size="15"
          stroke="red"
        />{" "}
      </span>
      <span
        style={{
          fontSize: 16,
          display: "block",
          width: "100%",
          marginLeft: "10px",
        }}
      >
        {t("global.globalNotifications.warning")}
      </span>
    </>
  );
}
